import { VerificationStatus } from "@wingspanhq/payments/dist/interfaces";
import React, { useEffect } from "react";
import { ManualAccountForm } from "../../../components/ManualAccountFormPreview/ManualAccountFormPreview";
import { SetupFlowRouteComponentProps } from "../../../components/SetupFlow/SetupFlow";
import { useUserId } from "../../../query/hooks/helpers";
import { useFeatureFlags } from "../../../query/hooks/useFeatureFlags";
import { paymentsService } from "../../../services/payments";
import { PaymentsSetupLayout } from "../../components/PaymentsSetupLayout/PaymentsSetupLayout";

export const SetupPayoutsConnectBankManually: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const userId = useUserId();
  const featureFlagsQuery = useFeatureFlags();

  useEffect(() => {
    if (!featureFlagsQuery.data?.verificationsByFeature) {
      paymentsService.service.update(userId, {
        verifications: {
          taxDocumentation: VerificationStatus.Verified,
          banking: VerificationStatus.Verified,
          cardPayments: VerificationStatus.Verified
        }
      });
    }
  }, []);

  return (
    <PaymentsSetupLayout
      onBack={onBack}
      title="Enter your bank routing & account numbers"
    >
      <ManualAccountForm
        onSubmit={onNext}
        submitButtonText="Continue"
        submitButtonName="continue"
      />
    </PaymentsSetupLayout>
  );
};
